var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { cachedSet } from '../../../utils/mobx/decorators/customComputed';
import { AttachedTrait } from '../../trait/attachedtrait/AttachedTrait';
import { TraitConditionEvaluator } from '../../trait/evaluator/TraitConditionEvaluator';
import { uniq } from '../../../utils/helper/lodash_replacements';
export class AspectImport {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get app() {
        return this.aspect.context.app;
    }
    get exporttraitsMatchingAspect() {
        return this.aspect.actor.actorImport.exporttraitsMatchingActor.filter((exporttrait) => this.isExportTraitMatching(exporttrait));
    }
    isExportTraitMatching(exporttrait) {
        return !exporttrait.value.aspectFilterFunctions
            .map((aspectFilter) => aspectFilter({ a: this.aspect, trait: exporttrait }))
            .includes(false);
    }
    get matchingActiveExportTraits() {
        return this.exporttraitsMatchingAspect.filter((et) => this.aspect.aspectAttached.toAttached(et).attachedCondition.isConditionTrue);
    }
    get traitsToImportFromExports() {
        return this.matchingActiveExportTraits.reduce((all, exportTrait) => all.concat(exportTrait.value.traitsToExport), []);
    }
    get traitsToImportFromTrait() {
        if (this.aspect.actor instanceof AttachedTrait) {
            return this.aspect.actor.trait.ownAspect[this.aspect.name].traits;
        }
        return [];
    }
    get traitsToImportFromCondition() {
        if (this.aspect.actor instanceof TraitConditionEvaluator) {
            if (!this.aspect.actor.traitCondition)
                return [];
            return this.aspect.actor.traitCondition.ownAspect[this.aspect.name].traits;
        }
        return [];
    }
    get traitsToImport() {
        return uniq(this.traitsToImportFromExports.concat(this.traitsToImportFromTrait, this.traitsToImportFromCondition));
    }
    get traitsWithImported() {
        if (this.aspect.parent.type === 'bundle') {
            return this.aspect.traits;
        }
        return this.aspect.traits.concat(this.traitsToImport).filter((trait) => trait.reg);
    }
}
__decorate([
    cachedSet
], AspectImport.prototype, "exporttraitsMatchingAspect", null);
__decorate([
    cachedSet
], AspectImport.prototype, "traitsToImportFromTrait", null);
__decorate([
    cachedSet
], AspectImport.prototype, "traitsToImportFromCondition", null);
__decorate([
    computed // @cachedSet
], AspectImport.prototype, "traitsToImport", null);
